export interface TemplateVariable {
  key: string;
  label: string;
  group: 'Contact' | 'Deal' | 'User';
}

export const TEMPLATE_VARIABLES: TemplateVariable[] = [
  { key: '{{contact.firstName}}', label: 'Contact First Name', group: 'Contact' },
  { key: '{{contact.lastName}}', label: 'Contact Last Name', group: 'Contact' },
  { key: '{{contact.email}}', label: 'Contact Email', group: 'Contact' },
  { key: '{{contact.company}}', label: 'Contact Company', group: 'Contact' },
  { key: '{{contact.jobTitle}}', label: 'Contact Job Title', group: 'Contact' },
  { key: '{{deal.name}}', label: 'Deal Name', group: 'Deal' },
  { key: '{{deal.stage}}', label: 'Deal Stage', group: 'Deal' },
  { key: '{{deal.value}}', label: 'Deal Value', group: 'Deal' },
  { key: '{{user.name}}', label: 'Your Name', group: 'User' },
  { key: '{{user.email}}', label: 'Your Email', group: 'User' },
  { key: '{{user.calendarLink}}', label: 'Your Calendar Link', group: 'User' },
];
